const { getStockReportFields } = require('./tools/prepare-facility-details')

const getFacilityStock = async (mainApi, { locationId, programId, serviceId }) => {
  const headers = await getStockReportFields(mainApi, serviceId)

  // Get current reporting period and product list
  const [period, productList] = await Promise.all([
    mainApi.report.period.get({
      programId,
      date: new Date(),
      isEffectiveDate: false
    }),
    mainApi.product.listForServices([serviceId])
  ])

  // Get current stock data
  const currentStock = await mainApi.report.findForLocation({
    locationId,
    period,
    includeChildren: false
  })
  const stockData = (currentStock && currentStock[0].stock) || {}

  // Transform to CSV data format
  const data = productList.map(product => {
    const productStock = stockData[product._id] || { fields: {} }
    const row = {}

    // Map fields using headers
    headers.forEach(header => {
      if (header.value === 'productId' || header.value === 'productName') {
        row['productId'] = product._id
        row['productName'] = product.name
      } else if (header.value === 'field:standard-remark') {
        row[header.value] = productStock.fields[header.value] && productStock.fields[header.value].amount
      } else {
        row[header.value] = productStock.fields[header.value] && productStock.fields[header.value].amount
      }
    })

    return row
  })

  return {
    headers,
    data
  }
}

module.exports = {
  getFacilityStock
}
